import React from "react";
import { Stack, StackProps } from "@mui/material";
const StackKit: React.FC<StackProps> = ({
  children,
  direction = "column",
  spacing = 2,
  ...props
}) => {
  return (
    <Stack direction={direction} spacing={spacing} {...props}>
      {children}
    </Stack>
  );
};

export default StackKit;
